import React, { useState } from "react";

import { Menu, MenuItem } from "@material-ui/core";

import { Button } from "../../../../common/components/libs";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks";
import { SnackbarType } from "../../../../stores/common";
import { CouponType } from "../../../../services/coupons/models";
import {Trans, useTranslation} from "react-i18next";
import { MenuFormType } from "../../../menu/store/menu/forms";

const ChooseCoupon = () => {
    const [couponSelectorAnchorEl, setCouponSelectorAnchorEl] = useState<HTMLElement | null>(null);
    const { generalStore, couponsStore } = useStores();
    const {i18n, t} = useTranslation(["general", "coupons"]);
    const locale = i18n.language;

    const handleOpenMenuSelectorMenu = ( event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setCouponSelectorAnchorEl(event.currentTarget);
    };

    const setCouponType = (couponType: CouponType) => {
        setCouponSelectorAnchorEl(null);
        couponsStore.setCouponType(couponType);
        couponsStore.getCoupons();
        generalStore.showSnackbar({
            type: SnackbarType.success,
            title:  t("general:labelOfUpdating")
        });
    };

    const currentType = couponsStore.getCouponType();

    const current =
        currentType === CouponType.all
            ? t("coupons:allCoupons")
            : currentType === CouponType.percentage
            ? t("coupons:discountInPercentages")
            : t("coupons:discountInCurrency");
    return (
        <React.Fragment>
            <Button
                mt={2}
                onClick={handleOpenMenuSelectorMenu}
                fullWidth
                variant={'outlined'}
                color={'default'}
                aria-owns={couponSelectorAnchorEl ? "coupon-selector" : undefined}
            >
                {current}
            </Button>
            <Menu
                id="menu-selector"
                anchorEl={couponSelectorAnchorEl}
                open={Boolean(couponSelectorAnchorEl)}
                onClose={() => setCouponSelectorAnchorEl(null)}
            >
                <MenuItem
                    onClick={() => {
                        setCouponType(CouponType.all);
                    }}
                >{t("coupons:allCoupons")}</MenuItem>
                <MenuItem
                    onClick={() => {
                        setCouponType(CouponType.percentage);
                    }}
                >{t("coupons:discountInPercentages")}</MenuItem>
                <MenuItem
                    onClick={() => {
                        setCouponType(CouponType.fixedAmount);
                    }}
                >{t("coupons:discountInCurrency")}</MenuItem>
            </Menu>
        </React.Fragment>
    );
};

export default observer(ChooseCoupon);
